module.exports = __webpack_public_path__ + "static/media/programci_yakinda.6bfbe0e8.jpg";